"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var redux_1 = require("redux");
var constants_1 = require("./constants");
var Section_1 = require("../../utils/Section");
var api_1 = require("../../utils/api");
var ramda_1 = require("ramda");
var getApp = function (draftState, appId) {
    var _a, _b, _c, _d;
    var favRail = (_b = (_a = draftState === null || draftState === void 0 ? void 0 : draftState.data) === null || _a === void 0 ? void 0 : _a.rails) === null || _b === void 0 ? void 0 : _b.find(function (rail) {
        return ramda_1.equals(rail === null || rail === void 0 ? void 0 : rail.__typename, 'FavouriteAppsGroup');
    });
    return (_d = (_c = favRail === null || favRail === void 0 ? void 0 : favRail.contentPage) === null || _c === void 0 ? void 0 : _c.content) === null || _d === void 0 ? void 0 : _d.find(function (application) { return ramda_1.equals(application.id, appId); });
};
exports.default = redux_1.combineReducers(__assign({ installed: api_1.createCustomModuleReducer((_a = {},
        _a[constants_1.SET_INSTALLED_APPS] = function (state, action) { return action.payload; },
        _a), []), allApps: api_1.createApiModuleReducer({
        actionType: constants_1.FETCH_ALL_APPS,
        onSuccess: function (draftState, action) {
            var _a;
            draftState.data = (_a = action.payload) === null || _a === void 0 ? void 0 : _a.myBoxApps;
        },
        onFailure: function (draftState) {
            draftState.error = 'myBoxApps-error';
        },
    }, []) }, Section_1.getReducers(constants_1.namespace, __assign(__assign({}, api_1.createApiReducer({
    actionType: constants_1.SET_FAVOURITE_APP,
    onSuccess: function (draftState, action) {
        var _a, _b, _c, _d, _e, _f;
        var _g = action.meta, appId = _g.appId, isFavourite = _g.isFavourite, removeFromList = _g.removeFromList;
        var app = getApp(draftState, appId);
        if (app) {
            app.favourite = isFavourite;
        }
        if (removeFromList) {
            var favRail = (_b = (_a = draftState === null || draftState === void 0 ? void 0 : draftState.data) === null || _a === void 0 ? void 0 : _a.rails) === null || _b === void 0 ? void 0 : _b.find(function (rail) {
                return ramda_1.equals(rail === null || rail === void 0 ? void 0 : rail.layout, 'FAVOURITE_APPS');
            });
            var favAppIndex = (_d = (_c = favRail === null || favRail === void 0 ? void 0 : favRail.contentPage) === null || _c === void 0 ? void 0 : _c.content) === null || _d === void 0 ? void 0 : _d.indexOf(app);
            (_f = (_e = favRail === null || favRail === void 0 ? void 0 : favRail.contentPage) === null || _e === void 0 ? void 0 : _e.content) === null || _f === void 0 ? void 0 : _f.splice(favAppIndex, 1);
        }
    },
    onFailure: function (draftState) {
        draftState.error = 'favourite-app';
    },
})), api_1.createApiReducer({
    actionType: constants_1.SET_LAST_OPENED_APP,
    onSuccess: function (draftState, action) {
        var _a;
        var appId = action.meta.appId;
        var app = getApp(draftState, appId);
        if (app) {
            app.lastOpened = (_a = action.payload) === null || _a === void 0 ? void 0 : _a.boxAppOpened;
        }
    },
    onFailure: function (draftState) {
        draftState.error = 'last-opened-app';
    },
})))));
//# sourceMappingURL=reducer.js.map